import React, { Component } from "react";
import { Button, FormGroup, FormControl, ControlLabel } from "react-bootstrap";
import logologin from '../../Comman/images/logo.png'
import logobackground from '../../Comman/images/loginbg.png'
import { Redirect, withRouter ,Link} from 'react-router-dom'
import '../../Comman/assets/css/user/style.css'
import loader from '../../Comman/images/loader.gif'
import SimpleReactValidator from 'simple-react-validator';
import { baseUrl } from '../../Comman/apiEndPoints';
import OtpInput from 'react-otp-input';
class ResetPasswordComponent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      otp:'',
      currentScreen:'otp',
      resetPassword:{
        Password:"",
        ConfirmPassword:''
      }
    };
   this.handleVerifyOtp=this.handleVerifyOtp.bind(this)
   
  }
  componentWillMount() {

        this.validator = new SimpleReactValidator();
    
  }
  
       componentWillReceiveProps(nextProps) {
      if(nextProps.resetPassword!=this.props.resetPassword){
      
         if(nextProps.resetPassword.otpstatusCode==200 ){
       this.setState({currentScreen:'reset'})
        }
        
        
    }
    }
  // renderRedirect = () => {
  //   this.props.history.push('/login')
    
  // }

  handleChange = event => {
    let value = event.target.value;
    let name = event.target.name;
    this.setState( prevState => ({ resetPassword : 
             {...prevState.resetPassword, [name]: value}
       }))
  }

  ResetPassword = event => {
    event.preventDefault();
    if (this.validator.allValid()) {
     // let resetPassword=this.state.resetPassword;
     // resetPassword.PasswordResetToken=this.props.match.params.id
      let resetPassword={
        UserId:parseInt(this.props.match.params.id),
        Password:this.state.resetPassword.Password
      }
      this.props.ResetPassword(resetPassword);
    }
    else{
      this.validator.showMessages();
      
      this.forceUpdate();
    }
    
  }
  ResetPassword1 = event => {
    event.preventDefault();
   
     let data=
     {
       "UserId": this.props.UserId.replace(/[^0-9]/g, ""),
    "OTP": this.state.otp
     }
      
      this.props.ResetPassword1(data);
      
    
    
    
  }
handleVerifyOtp = (otpCode) => {
   this.setState({otp:otpCode})
}
 
  render() {
     let backgroundImage,logoImageUrl,signingtext
     
          
           if(this.props.resetPassword.brandList.length !=0)
           {
        backgroundImage=baseUrl+this.props.resetPassword.brandList[0].BackGroundImage;
        logoImageUrl=baseUrl+this.props.resetPassword.brandList[0].BannerImage;
        signingtext=this.props.resetPassword.brandList[0].SigningText;
           } 
    return (
       <div>
        {
          this.props.resetPassword.brandList.length !=0 ?
      <div>
        {
          this.state.currentScreen !='otp'? 
          <div className="loginbg" style={{backgroundImage:"url(" + backgroundImage + ")",backgroundRepeat:"no-repeat",backgroundPosition:"center center",backgroundSize:"cover",backgroundAttachment:"fixed"}}>
        <div className="login-main reset-form" style={{background:"white",padding:"60px",position:"absolute",top:"50%",left:"50%",msTransform:"translateX(-50%) translateY(-50%)",WebkitTransform:"translate(-50%,-50%)",transform:"translate(-50%,-50%)",width:"50vh"}}>
          <div className="login-logo">
            <img src={logoImageUrl} alt="" />
          </div>
          <div className="k-form-field">
          <h3 > Reset Password</h3>
          
          {
            this.props.resetPassword.statusCode!=200?
               this.props.resetPassword.errorMessage!=''?
            <div class="alert alert-danger">
              <strong>{this.props.resetPassword.errorMessage}</strong> 
              
            </div>
            :'':
            <div class="alert alert-success">
              <strong>{this.props.resetPassword.errorMessage}</strong> 
              {/* <span className="pl-md-2">
                  <Link to="/superadmin">Login</Link>
               </span> */}
            </div>

          }
          
          <form onSubmit={this.ResetPassword} >
          <div className="login-fm">
            <FormGroup controlId="username">
             
              <FormControl
                className="login-main-form-control"
                autoFocus
                type="password"
                name="Password"
                value={this.state.resetPassword.Password}
                onChange={this.handleChange}
                placeholder="Password"
              />
              {this.validator.message('Password', this.state.resetPassword.Password, 'required|min:6')}

            </FormGroup>
            </div>
              <div className="login-fm">
            <FormGroup controlId="password">
             
              <FormControl
                className="login-main-form-control"
                value={this.state.resetPassword.ConfirmPassword}
                name="ConfirmPassword"

                onChange={this.handleChange}
                type="password"
                placeholder="Confirm Password"
              />
              {this.validator.message('ConfirmPassword',
               this.state.resetPassword.ConfirmPassword, 
               `required|in:${this.state.resetPassword.Password}`, 
               {messages: {in: 'Passwords need to match!'}})
              }

            </FormGroup>
            </div>
              
            <div className="login-button">
              <Button type="submit"> Save 
               
                {
                  this.props.resetPassword.isLoading?
                  <i className="fa fa-spinner fa-spin pl-md-2" ></i>
                  :'' 
                }
                </Button>
              <p>
                
                
                
              </p>
            </div>
          </form>
                      <p style={{color:"black !important",fontSize:"11px !important",marginTop:"0 !important"}} dangerouslySetInnerHTML={{ __html: signingtext }} ></p>

        </div>
      </div>
      </div>:<div className="loginbg" style={{backgroundImage:"url(" + backgroundImage + ")",backgroundRepeat:"no-repeat",backgroundPosition:"center center",backgroundSize:"cover",backgroundAttachment:"fixed"}}>
        <div className="login-main reset-form" style={{background:"white",padding:"60px",position:"absolute",top:"50%",left:"50%",msTransform:"translateX(-50%) translateY(-50%)",WebkitTransform:"translate(-50%,-50%)",transform:"translate(-50%,-50%)",width:"50vh"}}>
          <div className="login-logo">
            <img src={logoImageUrl} alt="" />
          </div>
          <div className="k-form-field">
          <h3 style={{marginBottom:'1px'}}> Enter OTP </h3>
         
          {
            this.props.resetPassword.otpstatusCode!=200?
               this.props.resetPassword.errorMessage!='' ?
            <div class="alert alert-danger">
              <strong>{this.props.resetPassword.errorMessage}</strong> 
              
            </div>
            :'':
            <div class="alert alert-success">
              <strong>{this.props.resetPassword.errorMessage}</strong> 
              <span className="pl-md-2">
                  <Link to="/superadmin">Login</Link>
               </span>
            </div>

          }
          
          <form onSubmit={this.ResetPassword1} >
          <div className="login-fm" style={{fontSize:'4.5vh'}}>
            <OtpInput
      value={this.state.otp}
      onChange={this.handleVerifyOtp}
      numInputs={6}
      renderSeparator={<span>-</span>}
      inputType="tel"
      renderInput={(props) => <input {...props} />}
    />
            </div>
              
            <div className="login-button" style={{marginTop:'15px'}}>
              <Button type="submit"> Next
               
                {
                  this.props.resetPassword.isLoading?
                  <i className="fa fa-spinner fa-spin pl-md-2" ></i>
                  :'' 
                }
                </Button>
              <p>
                
                
                
              </p>
              
            </div>
          </form>
          <p style={{color:"black !important",fontSize:"11px !important",marginTop:"0 !important"}} dangerouslySetInnerHTML={{ __html: signingtext }} ></p>
        </div>
      </div>
      </div>
        }

      
      
      </div>:''
  }
  </div>
    );
  }
}

export default withRouter(ResetPasswordComponent)